var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageAt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 32.5C6.5 33.6493 6.95655 34.7515 7.7692 35.5641C8.58186 36.3768 9.68406 36.8333 10.8333 36.8333H36.8333L45.5 45.5V10.8333C45.5 9.68406 45.0435 8.58186 44.2308 7.7692C43.4181 6.95655 42.3159 6.5 41.1667 6.5H10.8333C9.68406 6.5 8.58186 6.95655 7.7692 7.7692C6.95655 8.58186 6.5 9.68406 6.5 10.8333V32.5Z",
    stroke: "#2B2F51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 24.3334C27.8408 24.3334 29.3332 22.841 29.3332 21.0001C29.3332 19.1591 27.8408 17.6667 25.9998 17.6667C24.1589 17.6667 22.6665 19.1591 22.6665 21.0001C22.6665 22.841 24.1589 24.3334 25.9998 24.3334Z",
    stroke: "#2B2F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 17.6667V21.8334C29.3332 22.4964 29.5966 23.1323 30.0654 23.6012C30.5343 24.07 31.1701 24.3334 31.8332 24.3334C32.4962 24.3334 33.1321 24.07 33.6009 23.6012C34.0698 23.1323 34.3332 22.4964 34.3332 21.8334V21.0001C34.3331 19.1192 33.6967 17.2938 32.5276 15.8205C31.3584 14.3472 29.7253 13.3127 27.8937 12.8853C26.0621 12.4579 24.1398 12.6626 22.4393 13.4662C20.7388 14.2698 19.3602 15.625 18.5276 17.3115C17.6949 18.998 17.4573 20.9165 17.8533 22.7551C18.2493 24.5938 19.2557 26.2444 20.7087 27.4386C22.1617 28.6328 23.976 29.3003 25.8566 29.3327C27.7371 29.365 29.5733 28.7603 31.0665 27.6167",
    stroke: "#2B2F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAt);
export default __webpack_public_path__ + "static/media/message-at.5a27260a9d582b6a5b9e76d12da4d20d.svg";
export { ForwardRef as ReactComponent };